/** Legacy Molwe platform commission applied to donations before the CloudTips conditions switch. */
export const LEGACY_MOLWE_COMMISSION_PERCENT = 12;

/**
 * CloudTips switched receiver Molwe commission to 0% on 2026-09-29 (Moscow time).
 * Donations on or after this moment are credited to the author in full.
 * CloudTips payer fee (optional, ~9.6%) must not reduce the author's credited amount.
 */
export const MOLWE_ZERO_COMMISSION_SWITCHED_AT = new Date('2026-09-29T00:00:00+03:00');
